import { Component, OnInit } from "@angular/core";
import { GroupedChartRow, GroupedChartSeries, InfoCards, RetentionSegment } from "../../../_models";
import { CardState, DoughnutChartData, InlineTableData, PerfTableColumn, retentionValueCols } from "../../data-visualization";
import {
  OrdersBillingDualCard,
  OrdersBillingSingleCard,
  ProductViewType,
  ordersBillingDualCards,
  ordersBillingSingleCards,
  ordersCampaignData,
  ordersCancellationReasons,
  ordersCustomerStageData,
  ordersDoughnutData,
  ordersOfferTypeData,
  ordersProductData,
  ordersSummaryTableData,
  ordersTopCards,
} from "../../orders/orders.data";

@Component({
  selector: "app-orders-report",
  templateUrl: "./orders-report.component.html",
  styleUrls: ["./../../dashboard-section-v2.scss", "./../dashboard-report.component.scss"],
})
export class DashboardOrdersReportComponent implements OnInit {
  topCards: InfoCards = ordersTopCards;
  doughnutData: DoughnutChartData = ordersDoughnutData;
  summaryTableData: InlineTableData = ordersSummaryTableData;
  cancellationReasons = ordersCancellationReasons;
  billingDualCards: OrdersBillingDualCard[] = ordersBillingDualCards;
  billingSingleCards: OrdersBillingSingleCard[] = ordersBillingSingleCards;
  offerTypeData = ordersOfferTypeData;
  productData = ordersProductData;
  campaignData = ordersCampaignData;
  customerStageData = ordersCustomerStageData;

  // Stacked bar chart is unreadable at report width - print it as a table.
  cancellationState: CardState<any> = { data: [], loading: false, noData: true };
  cancellationNameCol: PerfTableColumn = { label: "Reason", field: "name" };
  cancellationValueCols: PerfTableColumn[] = [
    { label: "Requests", field: "requests" },
    { label: "Saved", field: "saved" },
    { label: "Cancelled", field: "cancelled" },
    { label: "Abandoned", field: "abandoned" },
  ];

  offerTypeNameCol: PerfTableColumn = { label: "Offer Type", field: "name" };
  offerTypeValueCols = retentionValueCols;
  productNameCol: PerfTableColumn = { label: "Product Name", field: "name" };
  productValueCols = retentionValueCols;
  campaignNameCol: PerfTableColumn = { label: "Name", field: "name" };
  campaignValueCols = retentionValueCols;
  customerStageNameCol: PerfTableColumn = { label: "Name", field: "name" };
  customerStageValueCols = retentionValueCols;

  constructor() {}

  ngOnInit() {
    // Chart used raw numbers; the other tables are formatted.
    const rows = this.cancellationReasons.data.map((row: GroupedChartRow) => {
      const mapped = {
        name: row.name,
        requests: (row.requests || 0).toLocaleString(),
        saved: "0",
        cancelled: "0",
        abandoned: "0",
      };
      row.series.forEach((entry: GroupedChartSeries) => {
        const value = (entry.value || 0).toLocaleString();
        if (entry.name === RetentionSegment.Saved) {
          mapped.saved = value;
        } else if (entry.name === RetentionSegment.Cancelled) {
          mapped.cancelled = value;
        } else if (entry.name === RetentionSegment.Abandoned) {
          mapped.abandoned = value;
        }
      });
      return mapped;
    });

    this.cancellationState = {
      data: rows,
      loading: this.cancellationReasons.loading,
      noData: this.cancellationReasons.noData,
    };
  }

  // No toggle in print - label whichever view is selected.
  get productViewLabel(): string {
    let label = "Base Product";
    if (this.productData.type === ProductViewType.Campaign) {
      label = "Campaign Product";
    }
    return label;
  }
}
